"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fragmentRings = fragmentRings;
const mf_parser_1 = require("mf-parser");
const openchemlib_utils_1 = require("openchemlib-utils");
const getFragmentableRings_js_1 = require("./utils/getFragmentableRings.js");
/**
 * The function performs the fragmentation of all single ring bonds not belonging to aromatic rings
 * @param {import('openchemlib').Molecule} molecule - The OCL molecule to be fragmented
 * @param {object} [options={}]
 * @param {boolean} [options.calculateHoseCodes=false] - calculating hose code for bonds is quite time consuming
 * @param {string} [options.parentIDCode=molecule.getIDCode()]
 * @returns  Array with results for the fragmentation of ring bonds
 */
function fragmentRings(molecule, options = {}) {
    const { Molecule } = molecule.getOCL();
    const { calculateHoseCodes, parentIDCode = molecule.getIDCode() } = options;
    const fragmentableRingBonds = (0, getFragmentableRings_js_1.getFragmentableRings)(molecule);
    let fragmentationResults = [];
    for (let ringBonds of fragmentableRingBonds) {
        const brokenMolecule = molecule.getCompactCopy();
        let fragmentMap = [];
        let atoms = [];
        let rLinks = {};
        for (let bond of ringBonds.bonds) {
            brokenMolecule.markBondForDeletion(bond.index);
            brokenMolecule.setAtomCustomLabel(bond.atom1, '*');
            brokenMolecule.setAtomCustomLabel(bond.atom2, '*');
            atoms.push(bond.atom1, bond.atom2);
            rLinks[bond.atom1] = bond.atom2;
            rLinks[bond.atom2] = bond.atom1;
        }
        brokenMolecule.deleteMarkedAtomsAndBonds();
        const nbFragments = brokenMolecule.getFragmentNumbers(fragmentMap);
        for (let i = 0; i < nbFragments; i++) {
            const result = {};
            if (calculateHoseCodes) {
                result.hoses = (0, openchemlib_utils_1.getHoseCodesForAtoms)(molecule, atoms);
            }
            result.atomMap = [];
            let includeAtom = fragmentMap.map((id) => {
                return id === i;
            });
            let fragment = new Molecule(0, 0);
            let atomMap = [];
            brokenMolecule.copyMoleculeByAtoms(fragment, includeAtom, false, atomMap);
            // if includeAtom has more then 3 true all true should become false and all false should become true
            for (let j = 0; j < atomMap.length; j++) {
                if (fragment.getAtomCustomLabel(atomMap[j]) === '*') {
                    result.atomMap.push(j);
                    if (rLinks[j] !== undefined) {
                        fragment.addBond(atomMap[j], fragment.addAtom(154));
                    }
                }
            }
            fragment.removeAtomCustomLabels();
            fragment.setFragment(false);
            //      console.log(fragment.getIDCode(), getMF(fragment).mf);
            result.idCode = fragment.getIDCode();
            result.parentIDCode = parentIDCode;
            result.cleavedBonds = ringBonds.bonds;
            result.mfInfo = new mf_parser_1.MF((0, openchemlib_utils_1.getMF)(fragment).mf.replace(/R[1-9]?/, '')).getInfo();
            result.fragmentType = 'cyclic';
            fragmentationResults.push(result);
        }
    }
    fragmentationResults = fragmentationResults.sort((a, b) => {
        return a.mfInfo.monoisotopicMass - b.mfInfo.monoisotopicMass;
    });
    return fragmentationResults;
}
//# sourceMappingURL=fragmentRings.js.map